<template>
  <div class="domain-list">
    <div v-if="!domains.length" class="domain-list__empty">{{ emptyText || $t("satellites.page.no_domains") }}</div>
    <div v-for="domain in shown" :key="domain.id" class="domain-list__row">
      <span class="domain-list__host">{{ domain.host }}</span>
      <span v-if="domain.router" class="domain-list__router"><SatIcon name="route" :size="13" /> {{ domain.router.name }}</span>
      <span v-else class="domain-list__router _none"><SatIcon name="alert" :size="13" /> {{ $t("satellites.domains.no_router") }}</span>
      <PlacementBadge :placement="domain.placement" class="domain-list__placement" />
      <router-link :to="{ name: 'SatelliteLinks', query: { domain: domain.id } }" class="sat-icon-btn" :title="$t('satellites.links.open')"><SatIcon name="link" :size="15" /></router-link>
    </div>
    <button v-if="domains.length > limit && !expanded" type="button" class="domain-list__more" @click="expanded = true">
      {{ $t("satellites.page.show_all", { count: domains.length }) }}
    </button>
  </div>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";
import PlacementBadge from "@/components/Satellites/PlacementBadge.vue";

// Read-only list of domains with their routers and placements (satellite and group pages).
export default {
  name: "DomainList",
  components: { SatIcon, PlacementBadge },
  props: {
    domains: {
      type: Array,
      required: true,
    },
    emptyText: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return { expanded: false };
  },
  computed: {
    shown() {
      return this.expanded ? this.domains : this.domains.slice(0, this.limit);
    },
  },
};
</script>
<style lang="scss" scoped>
.domain-list__empty {
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 13px;
  color: var(--sat-muted);
  background: var(--sat-surface);
}

.domain-list__row {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr) auto 32px;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid var(--sat-border);

  &:last-of-type {
    border-bottom: 0;
  }

  @media (max-width: 575px) {
    grid-template-columns: minmax(0, 1fr) 32px;

    .domain-list__router,
    .domain-list__placement {
      display: none;
    }
  }
}

.domain-list__host {
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.domain-list__router {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--sat-text-2);

  &._none {
    color: var(--sat-warn);
  }
}

.domain-list__more {
  margin-top: 8px;
  padding: 0;
  border: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--sat-accent);
  background: transparent;
  cursor: pointer;

  &:focus {
    outline: none;
  }
}
</style>
